<template>
  <div class="my-10">
    <div class="flex flex-col sm:flex-row justify-between px-4 items-center">
      <h1 class="text-3xl font-bold text-center mb-4 sm:mb-0">{{ __("Brands") }}</h1>

      <div class="flex items-center flex-shrink-0">
        <div>
          <inertia-link :href="route('carMakes.create')" class="btn-primary">
            {{ __("Add brand") }}
          </inertia-link>
        </div>
      </div>
    </div>

    <div class="bg-white p-4 shadow-md mt-10 ">
      <table class="w-full" v-if="carMakes.data.length">
        <tr class="bg-gray-700 text-gray-100">
          <th class="p-4 w-10">{{ __("Id") }}</th>
          <th class="p-4 text-left w-32">{{ __("Image") }}</th>
          <th class="p-4 text-left">{{ __("Name") }}</th>
          <th class="p-4 text-right w-24">{{ __("Actions") }}</th>
        </tr>

        <tr v-for="(carMake, index) in carMakes.data" :class="{'bg-gray-300': index%2 === 0}">
          <td class="p-4 text-center">{{ carMake.id }}</td>
          <td class="p-4">
            <img v-if="carMake.brand_image_url" :src="carMake.brand_image_url" :alt="carMake.name" class="h-12 w-20 object-contain">
            <span v-else class="text-gray-500">{{ __("No image") }}</span>
          </td>
          <td class="p-4">
            <inertia-link :href="route('carMakes.edit', {carMake: carMake.id})" class="text-coral-400 hover:text-gray-500 font-semibold">
              {{ carMake.name }}
            </inertia-link>
          </td>
          <td class="px-4 text-center">
            <div class="flex items-center w-full justify-end">
              <inertia-link :href="route('carMakes.edit', {carMake: carMake.id})" class="list-edit-button mr-2">
                <icon name="edit" class="w-4 h-4 fill-current"></icon>
              </inertia-link>
              <button @click="destroy(carMake)" class="list-delete-button">
                <icon name="delete" class="w-4 h-4 fill-current"></icon>
              </button>
            </div>
          </td>
        </tr>
      </table>
      <div v-else>
        {{ __("No brands at the moment...") }}
      </div>
    </div>

    <pagination :links="carMakes.meta.links"/>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import Icon from '@/Shared/Icon';
  import Pagination from '@/Shared/Pagination';

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: this.__("Brands"),
      }
    },
    props: {
      carMakes: Object,
    },
    components: {
      Layout,
      Icon,
      Pagination,
    },
    methods: {
      destroy(carMake) {
        if (confirm(this.__("Are you sure you want to delete :name brand?", {name: carMake.name}))) {
          this.$inertia.delete(this.route('carMakes.destroy', {carMake: carMake.id}));
        }
      }
    }
  }
</script>
